module.exports = __webpack_public_path__ + "static/media/autonomy.04702291.svg";